export const bookingFormConfigurationQueryKeys = {
  all: ["orchestratorBookingFormConfiguration"] as const,
  configs: () => [...bookingFormConfigurationQueryKeys.all, "config"] as const,
  config: (propertyTicker: string) =>
    [...bookingFormConfigurationQueryKeys.configs(), { propertyTicker }] as const,
};
